import React, { useEffect, useContext } from 'react'
import LoadingOverlay from 'react-loading-overlay'
import { Card, CardBody, Row, Col } from 'reactstrap'
import ConfigContext from './ConfigContext'

const ConfigCardsList = ({ onConfigSelect }) => {
    // const { loading, configTypes, loadConfigTypes } = useContext(ConfigContext)
    const { loading } = useContext(ConfigContext)

    // useEffect(() => {
    //     loadConfigTypes()
    // }, [])

    const configSections = [
        {
            title: 'New Stop Configuration',
            cards: [
                {
                    type: 'AUTO_APPT_CONFIG',
                    title: 'Auto Appointment Config',
                    description: 'Configure automatic appointment settings and rules',
                    color: 'primary',
                    enabled: false
                },
                {
                    type: 'APPT_REQ_ORD_PROC_CFG',
                    title: 'Pending Approval Config',
                    description: 'Configure pending approval workflow settings',
                    color: 'warning',
                    enabled: true
                },
                {
                    type: 'LOC_MAPPING_RULES',
                    title: 'Location Mapping Rules',
                    description: 'Configure location mapping rules for appointment system routing',
                    color: 'info',
                    enabled: true
                }
            ]
        },
        {
            title: 'Pre Appointment Configuration',
            cards: [
                {
                    type: 'APPT_TIME_CUSTOMISATION',
                    title: 'Appointment Time Customisation',
                    description: 'Configure appointment time slots and availability',
                    color: 'info',
                    enabled: false
                },
                {
                    type: 'APPT_REQUEST_CUSTOMISATION',
                    title: 'Appointment Request Customisation',
                    description: 'Configure appointment request forms and validation',
                    color: 'info',
                    enabled: false
                },
                {
                    type: 'EMAIL_GLOBAL_CHANGES',
                    title: 'Email Global Changes',
                    description: 'Configure global email template modifications',
                    color: 'info',
                    enabled: false
                }
            ]
        },
        {
            title: 'Post Appointment Configuration',
            cards: [
                {
                    type: 'POST_APPT_CONFIRM_FF',
                    title: 'Post Appointment Confirmation Validation Config',
                    description: 'Configure post-appointment confirmation rules and conditions',
                    color: 'success',
                    enabled: true  
                },
                {
                    type: 'POST_APPT_WORKFLOW_CONFIG',
                    title: 'Post Appointment Confirmation Workflow Config',
                    description: 'Configure post-appointment workflow processes',
                    color: 'success',
                    enabled: false
                },
                {
                    type: 'RETRY_CONFIGURATIONS',
                    title: 'Retry Configurations',
                    description: 'Configure retry logic and failure handling',
                    color: 'success',
                    enabled: false
                }
            ]
        },
        {
            title: 'Notification',
            cards: [
                {
                    type: 'NOTIFICATION_EMAIL_CONFIG',
                    title: 'Notification Email Config',
                    description: 'Configure notification email templates and settings',
                    color: 'secondary',
                    enabled: false
                }
            ]
        },
        {
            title: 'TMS Update',
            cards: [
                {
                    type: 'TMS_UPDATE_CUSTOMISATION',
                    title: 'TMS Update Customisation',
                    description: 'Configure TMS update processes and synchronization',
                    color: 'dark',
                    enabled: false
                }
            ]
        },
        {
            title: 'Email Appointment Management',
            cards: [
                {
                    type: 'FOLLOWUP_MGMT_DELETE',
                    title: 'Delete Followup',
                    description: 'Delete a followup record by tenant shortname and mail tracker.',
                    color: 'danger',
                    enabled: true
                },
                {
                    type: 'REOPEN_MANUAL_REVIEW',
                    title: 'Reopen Manual Review',
                    description: 'Reactivate a manual review so actions can be taken on it again.',
                    color: 'warning',
                    enabled: true
                },
                {
                    type: 'LLM_INSTR_TUNING',
                    title: 'LLM Instruction Tuning',
                    description: 'Set the extra instruction the appointment-response LLMs follow for a facility, and preview what it changes before saving.',
                    color: 'primary',
                    enabled: true
                }
            ]
        }
    ]
    
    const handleCardClick = (config) => {
        if (config.enabled) {
            onConfigSelect(config)
        }
    }

    return (
        <LoadingOverlay active={loading} spinner>
            <Card className='p-3'>
                <CardBody className="p-0">
                    {configSections.map((section, sectionIndex) => (
                        <div key={sectionIndex} className="mb-4">
                            <div className="mb-3">
                                <h6 className="text-secondary mb-0" style={{ 
                                    fontSize: '14px', 
                                    fontWeight: '600',
                                    borderBottom: '2px solid #EE5A29',
                                    paddingBottom: '8px',
                                    display: 'inline-block'
                                }}>
                                    {section.title}
                                </h6>
                            </div>
                            
                            <Row>
                                {section.cards.map((config, index) => (
                                    <Col lg={3} md={4} sm={6} key={config.type} className="mb-2">
                                        <Card 
                                            className={`border-2 shadow-sm config-card ${!config.enabled ? 'disabled-card' : ''}`}
                                            style={{ 
                                                cursor: config.enabled ? 'pointer' : 'not-allowed',
                                                transition: 'all 0.2s',
                                                opacity: config.enabled ? 1 : 0.6,
                                                position: 'relative'
                                            }}
                                            onClick={() => handleCardClick(config)}
                                            onMouseEnter={(e) => {
                                                if (config.enabled) {
                                                    e.currentTarget.style.transform = 'translateY(-2px)'
                                                    e.currentTarget.style.boxShadow = '0 4px 8px rgba(0,0,0,0.15)'
                                                }
                                            }}
                                            onMouseLeave={(e) => {
                                                if (config.enabled) {
                                                    e.currentTarget.style.transform = 'translateY(0)'
                                                    e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.1)'
                                                }
                                            }}
                                        >
                                            <CardBody className="text-center px-2" style={{ paddingTop: '8px', paddingBottom: '8px' }}>
                                                <h6 className="mb-2" style={{ fontSize: '13px', lineHeight: '1.1', color: '#EE5A29', fontWeight: '600' }}>
                                                    {config.title}
                                                </h6>
                                                <p className="text-muted small mb-2" style={{ fontSize: '11px', lineHeight: '1.1' }}>
                                                    {config.description}
                                                </p>
                                                <div className="text-primary small" style={{ fontSize: '10px', cursor: 'pointer', textDecoration: 'underline'}}>
                                                    Click to get details
                                                </div>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                ))}
                            </Row>
                        </div>
                    ))}
                </CardBody>
            </Card>
        </LoadingOverlay>
    )
}

export default ConfigCardsList